<lh-workbench>
  <ng-template lhWorkbenchTemplate="main">
    <router-outlet/>
  </ng-template>
</lh-workbench>
